import React from 'react';

import { TOOLS } from './config';
import { useMediaStudio } from './context/MediaStudioContext';
import MediaStudioTopBar from './components/media-studio-top-bar/MediaStudioTopBar';
import MediaStudioLayerContextMenu from './components/media-studio-layer-context-menu/MediaStudioLayerContextMenu';
import WorkspaceChrome from './components/workspace-chrome/WorkspaceChrome';
import TextToolbar from './components/text-toolbar/TextToolbar';
import MediaStudioCanvas from './canvas/MediaStudioCanvas';
import SidePanel from './panels/side-panel/SidePanel';
import InspectorPanel from './panels/inspector-panel/InspectorPanel';

import scss from './MediaStudio.module.scss';

function MediaStudioWorkspace() {
  const { features, config, editor, viewport, selectedElement, textEditing, layoutMode } = useMediaStudio();
  const textElement = textEditing.textElement;
  const showTextToolbar = features.text && textElement && !textElement.locked && editor.tool !== TOOLS.CROP;
  const showSidePanel = features.sidePanel && config.panels.length > 0;
  const isInspectorDocked = layoutMode.isCompact && showSidePanel;

  return (
    <>
      <MediaStudioTopBar />

      <div className={scss.shell}>
        {showSidePanel ? <SidePanel withInspector={isInspectorDocked} /> : null}

        <div className={scss.workspace}>
          <div ref={viewport.containerRef} className={scss.canvasArea}>
            <MediaStudioCanvas />
            {showTextToolbar ? <TextToolbar /> : null}
            <WorkspaceChrome />
          </div>
        </div>

        {selectedElement && !isInspectorDocked ? <InspectorPanel /> : null}
      </div>

      {features.transform || features.download ? <MediaStudioLayerContextMenu /> : null}
    </>
  );
}

export default MediaStudioWorkspace;
